/**
 * Check if an event is a keypress of escape
 * @param evt {Event} - string to format
 * @returns {boolean}
 */
const isEscapeKey = (evt) => {
  let isEscape = false
  if ('key' in evt) {
    isEscape = evt.key === 'Escape' || evt.key === 'Esc'
  } else {
    isEscape = evt.keyCode === 27
  }
  
  return isEscape
}
  
/**
 * Function for creating a dom element from a template
 * @param {string} elemString for element to be created
 */
const createElement = (elemString) => {
  const elem = document.createElement('div')
  elem.innerHTML = elemString
  return elem.firstChild
}
  
/**
 * classNames: Returns a stringified version of an array of class names
 * @param {*} classNamesArray
 */
const classNames = (classNamesArray = []) => {
  return (
    (Array.isArray(classNamesArray) &&
        classNamesArray.filter(cn => cn !== '').join(' ')) ||
      ''
  )
}
  
/**
 * Given a DOM node and CSS selector, this function looks up the tree until it
 * finds another DOM node that matches the provided CSS selector.
 * 
 * This function should likely be removed as it exists within the react
 * testing library as a DOM util function. Also, it is not in use by
 * any other code.
 *
 * Modified polyfill for Element.closest found on MDN
 * https://goo.gl/8VF5W1
 *
 * @param {String} CSS selector
 * @param {HTMLElement} el Element to search relative from
 */
const closest = (selector, el) => {
  let matches = document.querySelectorAll(selector),
    i
  do {
    i = matches.length
    // eslint-disable-next-line no-empty
    while (--i >= 0 && matches.item(i) !== el) {}
  } while (i < 0 && (el = el.parentElement))
  return el
}
  
export { isEscapeKey, createElement, classNames, closest }
